import React, { Component } from 'react'
import { Table, Tooltip } from 'antd'
import 'antd/dist/antd.css';
import { Link } from 'react-router-dom'
import Preloader from '../../common/Preloader'
import NewHeader from '../../common/NewHeader'
import SideNav from '../../common/SideNav'
import ResultModal from '../../common/Modals/AddHospitalCategory'
import EditResultModal from '../../common/Modals/EditHospitalCategory'
import SweetAlert from 'react-bootstrap-sweetalert'
import NewFooter from '../../common/NewFooter'
import functions from '../../utils/functions'
import ajax from '../../utils/ajax'


class NewHospitalCategories extends Component {

    state = {
        dialog: false,
        edit: false,
        sweetAlert: false,
        categoryList: false,
        categoryName: "",
        categoryCode: "",
        categoryId: ""
    }

    recievedState = (data) => {
        this.setState({ dialog: data })
    }

    componentDidMount() {
        this.getAllCategories();
    }

    editRow = (key) => {

        this.setState({
            edit: true, 
            categoryName: key.categoryName,
            categoryCode: key.categoryCode, 
            categoryId: key.actioned
        })
    }

    deleteRow = (key) => {
        this.setState({ sweetAlert: true, categoryId: key })
    }

    onCancelDelet = () => {
        this.setState({ sweetAlert: false, categoryId: "" })
    }

    confirmDelete = async () => {

        const { categoryId } = this.state

        if (categoryId.length > 0) {

            const server_response = await ajax.deleteCategory(categoryId);

            if (server_response.status === "OK") {
                this.setState({
                    sweetAlert: false
                })
                window.location.reload()

            } else {

                this.setState({
                    sweetAlert: false
                })

            }
        } else {
            console.log("Nothing to delete")
        }

    }

    recievedEditState = (data) => {
        this.setState({ edit: data })
    }

    componentDidMount() {
        this.getAllCategories();
    }

    onClickRegister = () => {
        this.setState({
            dialog: true,
        })
    }

    onClickEdit = () => {
        this.setState({
            edit: true,
        })
    }

    getAllCategories = async () => {
        const server_response = await ajax.listCategories();
        const tableData = []

        if (server_response.status === "OK") {

            server_response.details.content.map((categories) =>
                tableData.push({
                    categoryName: categories.category_name,
                    categoryCode: categories.category_code,
                    // userId: categories.created_by.first_name + " " + categories.created_by.last_name + " - " + categories.created_by.user_role.role_name,
                    updated: categories.updated_on.long_date,
                    actioned: categories.category_id,
                }),
            )

            this.setState({
                categoryList: tableData
            })

        } else {
            // this.setState({
            //     categoryList: "404"
            // })
        }
    }


    render() {
        const columns = [
            {
                title: 'Hospital Category Name',
                dataIndex: 'categoryName',
            },
            {
                title: 'Hospital Category Code',
                dataIndex: 'categoryCode',
            },
            // {
            //     title: 'Added By ',
            //     dataIndex: 'userId',
            // },
            {
                title: 'Upddated On',
                dataIndex: 'updated',
            },
            {
                title: 'Actions - [ Edit, Delete ]',
                dataIndex: 'actioned',

                className: 'bg-transparent text-right',
                render: (text, records, index) => {
                    return (
                        <div className="text-nowrap">
                            <Tooltip
                                placement="leftTop"
                                title="Edit Category"
                                color="#454B1B"
                                key="#f50"
                                style={{ marginRight: "10px" }}
                            >
                                <button
                                    type="button"
                                    className="btn btn-light text-red"
                                    onClick={() => this.editRow(records)}

                                >
                                    <i className="fa fa-edit" />
                                </button>
                            </Tooltip>

                            <Tooltip
                                placement="leftTop"
                                title="Delete Category"
                                color="#f50"
                                key="#f50"
                            >
                                <button
                                    type="button"
                                    className="btn btn-light text-red"
                                    onClick={() => this.deleteRow(text)}
                                >
                                    <i className="fa fa-trash" />
                                </button>
                            </Tooltip>

                        </div>
                    )
                }
            },

        ]


        return (

            <body>
                {/* <!-- begin app --> */}
                <div class="app">
                    {/* <!-- begin app-wrap --> */}
                    <div class="app-wrap">
                        {/* <!-- begin pre-loader --> */}
                        <Preloader />
                        <NewHeader />
                        <div class="app-container">
                            <SideNav />
                            {/* <!-- begin app-main --> */}
                            <div class="app-main" id="main">
                                {/* <!-- begin container-fluid --> */}
                                <div class="container-fluid">
                                    {/* <!-- begin row --> */}
                                    <div class="row">
                                        <div class="col-md-12 m-b-30">
                                            {/* <!-- begin page title --> */}
                                            <div class="d-block d-sm-flex flex-nowrap align-items-center">
                                                <div class="page-title mb-2 mb-sm-0">
                                                    <h1>Clinic- Hospital Categories</h1>
                                                </div>
                                                <div class="ml-auto d-flex align-items-center">
                                                    <nav>
                                                        <ol class="breadcrumb p-0 m-b-0">
                                                            <li class="breadcrumb-item">
                                                                <a href="index.html"><i class="ti ti-home"></i></a>
                                                            </li>
                                                            <li class="breadcrumb-item">
                                                                System Settings
                                                            </li>
                                                            <li class="breadcrumb-item active text-primary" aria-current="page">Clinic- Hospital Categories</li>
                                                        </ol>
                                                    </nav>
                                                </div>
                                            </div>
                                            {/* <!-- end page title --> */}
                                        </div>
                                    </div>
                                    {/* <!-- end row --> */}
                                    {/* <!-- begin row --> */}
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="card card-statistics">
                                                <div class="card-body">

                                                    <div class="my-3">
                                                        <button type="button" onClick={this.onClickRegister} class="btn btn-primary"> Add Clinic Hospital Category</button>
                                                    </div>

                                                    <div class="datatable-wrapper table-responsive">

                                                        <Table
                                                            columns={columns}
                                                            bordered
                                                            // onChange={this.onchange}
                                                            dataSource={this.state.categoryList}
                                                            size="small"
                                                            pagination={{ pageSizeOptions: ['10'], showTitle: false, hideOnSinglePage: false }}

                                                        />


                                                        {this.state.dialog ? (
                                                            <ResultModal
                                                                visible={{ visible: true }}
                                                                handleCancel={this.recievedState}
                                                            />
                                                        ) : null}

                                                        {this.state.edit ? (
                                                            <EditResultModal
                                                                visible={{ visible: true, categoryName: this.state.categoryName, categoryCode: this.state.categoryCode, categoryId: this.state.categoryId }}
                                                                handleEditCancel={this.recievedEditState}
                                                            />
                                                        ) : null}

                                                        {this.state.sweetAlert ? (

                                                            <SweetAlert
                                                                warning
                                                                showCancel
                                                                confirmBtnText="Yes, delete it!"
                                                                confirmBtnBsStyle="danger"
                                                                title="Are you sure?"
                                                                onConfirm={this.confirmDelete}
                                                                onCancel={this.onCancelDelet}
                                                                focusCancelBtn
                                                            >
                                                                This action is cant be undone!
                                                            </SweetAlert>

                                                        ) : null}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- end row --> */}
                                </div>
                                {/* <!-- end container-fluid --> */}
                            </div>
                            {/* <!-- end app-main --> */}
                        </div>
                        {/* <!-- end app-container --> */}
                        <NewFooter />
                    </div>
                    {/* <!-- end app-wrap --> */}
                </div>
                {/* <!-- end app --> */}
            </body>

        )
    }
}
export default NewHospitalCategories